<template>
  <div>
    <div v-if="material_type === 1 " style="display: flex;padding-right:10px">
      <div>
        <div class="video-container">
          <video
            ref="videoEl"
            :src="allobj.aweme_url"
            autoplay
            loop
            muted
            controls
            class="video-box"
            @loadedmetadata="handleVideoMetadata"
          />
        </div>
      </div>
      <div style="width: 100%">
        <el-form label-width="130px">

          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="标题"
          >
            {{ allobj.title }}
          </el-form-item>
          <el-form-item
            label="小程序名"
            style="margin-bottom:10px;text-align: right;"
          >
            {{ allobj.mini_app_name }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="小说id"
          >
            {{ allobj.book_id }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="书籍名称"
          >
            {{ allobj.book_name }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="平台名称"
          >
            {{ allobj.platform }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="算法去重唯一id"
          >
            {{ allobj.unique_id }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="字数"
          >
            {{ allobj.word_count }}
          </el-form-item>
          <el-form-item
            style="margin-bottom: 10px;"
            label="视频地址"
          >
            <div style="display: flex; align-items: center;">
              <div
                style="max-width: 390px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-size: 14px;color: #606266;"
                :title="allobj.aweme_url"
              >
                {{ allobj.aweme_url }}
              </div>

              <el-button
                v-if="allobj.aweme_url"
                type="text"
                icon="el-icon-document-copy"
                style="margin-left: 8px;"
                @click="copy(allobj.aweme_url)"
              />

            </div>
          </el-form-item>
          <div class="data-row">
            <div class="item_data">
              <div class="value">{{ allobj.like_count }}</div>
              <div class="label">喜欢</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.heat }}</div>
              <div class="label">热度</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.comment_count }}</div>
              <div class="label">评论</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.share_count }}</div>
              <div class="label">分享</div>
            </div>
          </div>
        </el-form>
        <div
          class="scroll-container"
        />
      </div>
    </div>
    <div v-else style="display: flex;padding-right:10px">
      <div>
        <div class="video-container">
          <video
            ref="videoEl"
            :src="allobj.awemeUrl"
            autoplay
            loop
            muted
            controls
            class="video-box"
            @loadedmetadata="handleVideoMetadata"
          />
        </div>
      </div>
      <div style="width: 100%">
        <el-form label-width="100px">

          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="素材尺寸"
          >
            {{ allobj.materialWidth }} × {{ allobj.materialHeight }}
          </el-form-item>
          <el-form-item
            label="标题"
            style="margin-bottom:10px;text-align: right;"
          >
            {{ allobj.playletName }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="素材名称"
          >
            {{ allobj.creative ? allobj.creative.title1 : '' }}
          </el-form-item>
          <el-form-item
            style="margin-bottom:10px;text-align: right;"
            label="投放周期"
          >
            {{ allobj.materialFirstSeen }}-{{ allobj.materialLastSeen }}
          </el-form-item>
          <div class="data-row">
            <div class="item_data">
              <div class="value">{{ allobj.exposureNum }}</div>
              <div class="label">曝光量</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.downloadNum }}</div>
              <div class="label">转化量</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.materialDays }}</div>
              <div class="label">投放天数</div>
            </div>
            <div class="item_data">
              <div class="value">{{ allobj.creativeNum }}</div>
              <div class="label">计划数</div>
            </div>
          </div>
        </el-form>
        <div
          class="scroll-container"
        />
      </div>
    </div>

  </div>
</template>

<script>
import { materialInfo } from '@/api/report/dxj'

export default {
  data() {
    return {
      table_data: [],
      videoUrl: 'https://www.douyin.com/aweme/v1/play/?video_id=v0300fg10000cvqbitvog65pu652p4qg&line=0&file_id=13a318bc74c34cbea1f15a6dbadd5dbe&sign=c77551df4f15f261e2a2ff6793d47226&is_play_url=1&source=PackSourceEnum_AWEME_DETAIL',
      num: 0,
      allobj: {},
      material_type: null
    }
  },
  methods: {
    send(val, type) {
      console.log('material_id', val)
      // 小说素材
      if (type === 1) {
        this.material_type = 1
        materialInfo({ material_id: val.material_id }).then((res) => {
          console.log(res)
          this.allobj = res.data.detail
        })
      } else {
        this.material_id = val.material_id
        this.materialWidth = val.width
        this.materialHeight = val.height
      }
      // this.videoUrl = val.video_url
    },
    handleVideoMetadata() {

    },
    copy(data) {
      const newdata = data
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    }
  }
}
</script>

<style scoped>
.image-container {
  position: relative;
  width: 600px;
  height: 600px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #eee;
}

.image-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--bg-image);
  background-size: cover;
  background-position: center;
  filter: blur(10px);
  z-index: 1;
}

.image-content {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  z-index: 2;
}
.scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px 0;
  padding-left: 10px;
}

.scroll-wrapper {
  display: inline-block;
}

/* 每个方块的样式 */
.item {
  cursor: pointer;
  display: inline-block;
  width: 300px;
  height: 160px;
  margin-right: 10px;
  overflow: hidden;
  position: relative;
  border: 2px solid transparent;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: black;
}

.item.selected {
  border-color: #fc563d; /* 选中边框颜色 */
}

.item video {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持比例缩放，直到某一边溢出 */
  object-position: center;
  pointer-events: none;
}
.video-box {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.video-container {
  width: 400px;
  height: 544px;
  overflow: hidden;
  background: black;
}
.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 27px; /* 控制上下间距，不需要左右 padding */
  background: #f3f5f8;
  border-radius: 4px 4px 4px 4px;
  margin-left: 30px;
  margin-bottom: 20px;
}
.value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.label {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
.item_data {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px; /* 你可以根据字体大小微调 */
  flex-shrink: 0;
}
</style>
